import api from '@/utils/api'

const state = () => ({
  noticeList: [],
  noticeVisible: false
});
const getters = {
  totalCount: (state) => state.noticeList.length,
  unreadCount: (state) => state.noticeList.filter(item => item.unread).length
}
const mutations = {
  setNoticeList(state, payload) {
    state.noticeList = payload;
  },
  setNoticeVisible(state, payload) {
    state.noticeVisible = payload;
  }
};

const actions = {
  setNoticeVisible({ commit }, payload) {
    commit('setNoticeVisible', payload);
  },
  async getNoticeList({ commit },) {
    const { status, data } = await api.getNotificationList()
    if (status === 200) {
      commit('setNoticeList', data)
    }
  },
  async putNotification({ dispatch ,commit}, params) {
    const { status, data } = await api.putNotification(params)
    if (status === 200) {
      dispatch('getNoticeList', data)
      commit('setNoticeVisible', false)
    }
  },
  async putNotificationReadAll({ dispatch ,commit}, params) {
    const { status, data } = await api.putNotificationReadAll(params)
    if (status === 200) {
      dispatch('getNoticeList', data)
      commit('setNoticeVisible', false)
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};